var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinderIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finder-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4311C0 19.2855 5.57665 24.8621 12.4311 24.8621C19.2855 24.8621 24.8621 19.2855 24.8621 12.4311C24.8621 5.57665 19.2855 0 12.4311 0C5.57665 0 0 5.57665 0 12.4311ZM1.53598 12.4311C1.53598 6.42362 6.42362 1.53598 12.4311 1.53598C18.4385 1.53598 23.3262 6.42362 23.3262 12.4311C23.3262 18.4389 18.4385 23.3262 12.4311 23.3262C6.42362 23.3262 1.53598 18.4389 1.53598 12.4311Z",
    transform: "translate(0.5688955 0.5689678)",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.03687 14.0814C8.05133 14.0827 8.0658 14.0833 8.07994 14.0833C8.26732 14.0833 8.43597 13.9716 8.50863 13.799L14.0464 0.646323C14.1201 0.471428 14.0806 0.27089 13.9468 0.137089C13.8584 0.0489838 13.741 0 13.6167 0C13.5549 0 13.4951 0.0124925 13.4376 0.03682L0.284938 5.57462C0.0972212 5.65352 -0.0161976 5.84288 0.00188365 6.04539C0.0199649 6.2479 0.16593 6.41326 0.364495 6.45764L6.16464 7.74667C6.25077 7.76574 6.31816 7.8328 6.33723 7.91926L7.6256 13.7191C7.66998 13.9176 7.83567 14.063 8.03687 14.0814ZM12.2324 1.55367C12.2607 1.54151 12.2909 1.53559 12.3205 1.53559C12.3797 1.53559 12.4375 1.55861 12.4812 1.60233C12.5463 1.66742 12.5657 1.76605 12.5299 1.85119L8.49416 11.4362C8.45833 11.5211 8.37548 11.5753 8.28475 11.5753C8.27817 11.5753 8.27127 11.575 8.26436 11.5743C8.16574 11.5658 8.08454 11.4941 8.06284 11.3974L7.14957 7.28774C7.11045 7.11186 6.97139 6.97312 6.79617 6.934L2.6858 6.02073C2.58915 5.99904 2.51781 5.91751 2.50893 5.81921C2.50006 5.72058 2.55594 5.62755 2.64701 5.58941L12.2324 1.55367Z",
    transform: "translate(4.817956 7.098614)",
    id: "Fill-4",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinderIconWhite);
export default __webpack_public_path__ + "static/media/Finder-icon-white.acad3ea299a5cb812db5fddc64e217d3.svg";
export { ForwardRef as ReactComponent };